import React from 'react'
import { Switch as MuiSwitch, styled, SwitchProps } from '@mui/material'
import { COLORS } from '../../utils/constants'

const CustomSwitch = styled(MuiSwitch)(() => ({
  padding: 4,
  '& .MuiSwitch-switchBase': {
    margin: 4,
    padding: 2,
    '&.Mui-checked': {
      color: '#fff',
      transform: 'translateX(26px)',
      '& .MuiSwitch-thumb:before': {
        backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 20 20"><path fill="${encodeURIComponent(
          COLORS.GREEN,
        )}" d="m8.229 14.062-3.521-3.541L5.75 9.479l2.479 2.459 6.021-6L15.292 7Z"/></svg>')`,
      },
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: COLORS.GREEN,
      },
    },
  },
  '& .MuiSwitch-thumb': {
    backgroundColor: '#fff',
    '&:before': {
      content: "''",
      position: 'absolute',
      width: '100%',
      height: '100%',
      left: 0,
      top: 0,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="20" viewBox="0 0 20 20"><path fill="${encodeURIComponent(
        COLORS.GRAY,
      )}" d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z"/></svg>')`,
    },
  },
  '& .MuiSwitch-track': {
    opacity: 1,
    backgroundColor: COLORS.GRAY,
    borderRadius: 24,
    height: 24,
  },
}))

interface CustomSwitchProps extends Omit<SwitchProps, 'size'> {
  label?: string
}

export const Switch: React.FC<CustomSwitchProps> = ({ label, ...props }) => {
  return <CustomSwitch {...props} />
}

export default Switch
